<template>
    <div class="lg:w-[620px] lg_tall:w-[560px] h-[148px] flex justify-between pl-7 pr-5  bg-white rounded-xl">
        <div class="mt-3 flex flex-col gap-y-[10px]">
            <p class="text-main-1 text-small-size">{{ name }}</p>
            <p class="text-gray_1 text-content-size font-medium">{{ title }}</p>
            <p class="text-text-1 w-[472px] text-small-size">{{ description }}</p>
        </div>
        <img class="w-[78px] h-[78px] mt-3" :src="avaratUrl" alt="">
    </div>
</template>
<script>
export default {
    props: ['avaratUrl', 'name', 'title', 'description'],
    data() {
        return {
        }
    }
}
</script>